import { render, staticRenderFns } from "./interviewee.vue?vue&type=template&id=3b8d22f1&scoped=true&"
import script from "./interviewee.vue?vue&type=script&lang=js&"
export * from "./interviewee.vue?vue&type=script&lang=js&"
import style0 from "./interviewee.vue?vue&type=style&index=0&id=3b8d22f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d22f1",
  null
  
)

export default component.exports